<template>
    <main-layout>
        <div class="container">
            <H1 class="pageTitle">CHECKOUT</H1>
           
            <div id="checkoutTableDiv" class="top60">
                <cart></cart>
                <div class="has-text-right">
                    <button class="button is-warning top20" @click="proceed" :disabled="$root.cartContents == 0">Proceed to Payment</button>
                </div>
            </div>
            <br><br>

        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import Cart from '../components/Cart.vue'

export default {
  components: {
    MainLayout,
    Cart
  }, 
  methods:{
      proceed: function(){
          this.$router.push('/pmt')
      }
  }
}
</script>






// WEBPACK FOOTER //
// src/pages/Checkout.vue